var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.0833C3.5 10.7612 3.76117 10.5 4.08333 10.5L23.9167 10.5C24.2388 10.5 24.5 10.7612 24.5 11.0833L24.5 25.0833C24.5 25.4055 24.2388 25.6667 23.9167 25.6667H4.08333C3.76117 25.6667 3.5 25.4055 3.5 25.0833L3.5 11.0833Z",
    fill: "url(#paint0_linear_12284_5329)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 18.6663C11.6665 17.3777 12.7112 16.333 13.9998 16.333V16.333C15.2885 16.333 16.3332 17.3777 16.3332 18.6663V25.6663H11.6665L11.6665 18.6663Z",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3533 2.9165L7.64651 2.9165C7.24425 2.9165 6.87037 3.13668 6.65718 3.49911L1.72437 11.8849C1.48154 12.2977 1.76086 12.8332 2.21903 12.8332L25.7807 12.8332C26.2389 12.8332 26.5182 12.2977 26.2754 11.8849L21.3426 3.49911C21.1294 3.13668 20.7555 2.9165 20.3533 2.9165Z",
    fill: "url(#paint1_linear_12284_5329)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5873 9.51653L10.4998 12.833H17.4998L14.4122 9.51653C14.1844 9.27183 13.8151 9.27183 13.5873 9.51653Z",
    fill: "#E6E5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90261 16.333C6.63414 16.333 6.4165 16.5506 6.4165 16.8191V18.7636C6.4165 19.032 6.63414 19.2497 6.90261 19.2497H8.84706C9.11553 19.2497 9.33317 19.032 9.33317 18.7636V16.8191C9.33317 16.5506 9.11553 16.333 8.84706 16.333H6.90261Z",
    fill: "#8E8CEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1526 16.333C18.8841 16.333 18.6665 16.5506 18.6665 16.8191V18.7636C18.6665 19.032 18.8841 19.2497 19.1526 19.2497H21.0971C21.3655 19.2497 21.5832 19.032 21.5832 18.7636V16.8191C21.5832 16.5506 21.3655 16.333 21.0971 16.333H19.1526Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12284_5329",
    x1: 8.75,
    y1: 20.7917,
    x2: 13.4545,
    y2: 14.1049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D9D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703225,
    stopColor: "#E6E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12284_5329",
    x1: 16.6735,
    y1: 7.32391,
    x2: 18.3394,
    y2: 5.16796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.b268fb6f38f3f128a483b56235aeef66.svg";
export { ForwardRef as ReactComponent };